import { fetchResumenGeneral } from "../../../../services/ConsumosService";
import { useEffect, useState } from "react";
import CardConsumos from "./CardsConsumos";

function Cards({ periodo, tipo, estado, idAfiliado }) {
    const [resumenGeneral, setResumenGeneral] = useState({
        totalConsumos: 0,
        copagoTotal: 0,
        cantidadSolicitadaTotal: 0,
        promedioCostoMedicamento: 0,
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController();

        const fetchData = async () => {
            setLoading(true);
            try {
                const resumenGeneralData = await fetchResumenGeneral(periodo, tipo, idAfiliado, estado, controller.signal);
                setResumenGeneral(resumenGeneralData);
            } catch (error) {
                if (!controller.signal.aborted) {
                    setResumenGeneral({
                        totalConsumos: 0,
                        copagoTotal: 0,
                        cantidadSolicitadaTotal: 0,
                        promedioCostoMedicamento: 0,
                    });
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };

        fetchData();

        return () => {
            controller.abort();
        };
    }, [periodo, tipo, estado, idAfiliado])

    const formatNumber = (value, options = { currency: false }) => {
        if (value === null || value === undefined || isNaN(value))
            return options.currency ? "$ 0" : "0";

        let formatted = value;
        let suffix = "";

        if (value >= 1_000_000) {
            formatted = value / 1_000_000;
            suffix = " M";
        } else if (value >= 1_000) {
            formatted = value / 1_000;
            suffix = " K";
        }

        const formattedValue = new Intl.NumberFormat("es-AR", {
            minimumFractionDigits: formatted < 10 ? 1 : 0,
            maximumFractionDigits: formatted < 10 ? 1 : 0,
        }).format(formatted);

        return options.currency
            ? `$ ${formattedValue}${suffix}`
            : `${formattedValue}${suffix}`;
    };

    return (
        <div className="flex gap-4 mb-5 w-full">
            <CardConsumos
                title="Total consumos (UNIDAD)"
                value={`${formatNumber(resumenGeneral?.totalConsumos)}`}
                loading={loading}
            />
            <CardConsumos
                title="Copago total ($)"
                value={`${formatNumber(resumenGeneral?.copagoTotal, {
                    currency: true,
                })}`}
                loading={loading}
            />
            <CardConsumos
                title="Cantidad solicitada (UNIDAD)"
                value={`${formatNumber(resumenGeneral?.cantidadSolicitadaTotal)}`}
                loading={loading}
            />
            <CardConsumos
                title="Promedio costo medicamento ($)"
                value={`${formatNumber(resumenGeneral?.promedioCostoMedicamento, {
                    currency: true,
                })}`}
                loading={loading}
            />
        </div>
    );
}

export default Cards;